<template>
  <div id="app" class="compare-page page-template-default site container hfeed">
    <HeadNav selectedLanguage="en" page="og" :gotodownload="gotodownload" :apk="apk" />

    <div id="page" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main og-compare-wrap">
          <article class="inside-article section-content og-compare-article og-page-prose">
            <header class="entry-header og-compare-header">
              <h1 class="entry-title">OG WhatsApp vs GB WhatsApp — What Actually Changes?</h1>
              <p class="lead">
                Both are sideloaded Android mods. OG WhatsApp leans toward privacy tools and a layout that still feels close to stock. GB WhatsApp often goes harder on themes and visual tweaks. Neither is from WhatsApp LLC—pick a build you trust, then verify the APK.
              </p>
            </header>

            <div class="og-compare-callout" role="note">
              <p>
                <strong>Note:</strong> ogbwhats.com is independent. Features shift between forks; what you see on your phone beats anything we write here.
              </p>
            </div>

            <section class="og-compare-section" aria-labelledby="sec-table-overview">
              <h2 id="sec-table-overview">OG WhatsApp vs GB WhatsApp: quick comparison</h2>
              <div class="og-compare-table-scroll">
                <table class="og-compare-table" aria-describedby="cap-overview">
                  <caption id="cap-overview" class="og-compare-caption">OG WhatsApp vs GB WhatsApp — rough split</caption>
                  <thead>
                    <tr>
                      <th scope="col">Topic</th>
                      <th scope="col">OG WhatsApp</th>
                      <th scope="col">GB WhatsApp</th>
                      <th scope="col">Tip</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Look</th>
                      <td>Stock-ish plus extras; theme depth varies</td>
                      <td>More theme packs, heavier UI play</td>
                      <td>Big Android update? Re-check themes before you blame the fork</td>
                    </tr>
                    <tr>
                      <th scope="row">Privacy</th>
                      <td>Ticks, online status, recording indicator—usually front and center</td>
                      <td>Same ideas, different menu names</td>
                      <td>Hiding ticks ≠ invisible to WhatsApp’s servers—just your screen</td>
                    </tr>
                    <tr>
                      <th scope="row">Updates</th>
                      <td>Outside Play Store; whoever ships your APK sets the pace</td>
                      <td>Same story</td>
                      <td>Skim Telegram/forum notes after OS bumps before you flash</td>
                    </tr>
                    <tr>
                      <th scope="row">Menus</th>
                      <td>Often fewer “where did that toggle go?” moments</td>
                      <td>More switches—more to reset after each update</td>
                      <td>Jot down the 5 things you actually use; match them in Settings</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section class="og-compare-section" aria-labelledby="sec-definitions">
              <h2 id="sec-definitions">What OG WhatsApp and GB WhatsApp mean</h2>
              <p>
                <strong>OG WhatsApp</strong> is what people call a bunch of unofficial forks that bolt privacy and media helpers onto the chat you already know. If you’re hunting an <strong>OG WhatsApp APK</strong>, you’re usually after those extras without juggling three helper apps.
              </p>
              <p>
                <strong>GB WhatsApp</strong> is the older label people still search when they want wild themes, dual numbers, or long forum threads full of screenshots. The label doesn’t prove the file is clean—only your download path does.
              </p>
            </section>

            <section class="og-compare-section" aria-labelledby="sec-scenarios">
              <h2 id="sec-scenarios">Choosing OG WhatsApp or GB WhatsApp: where to start</h2>
              <div class="og-compare-table-scroll">
                <table class="og-compare-table og-compare-table--compact">
                  <caption class="og-compare-caption">Where to dig first</caption>
                  <thead>
                    <tr>
                      <th scope="col">You want…</th>
                      <th scope="col">Try first</th>
                      <th scope="col">Why</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Quiet privacy toggles without losing your mind</th>
                      <td>OG WhatsApp write-ups + our <router-link :to="{ name: 'en-download' }">download</router-link> notes</td>
                      <td>Less theme rabbit hole, more day-to-day settings talk</td>
                    </tr>
                    <tr>
                      <th scope="row">A phone that looks nothing like stock</th>
                      <td>GB WhatsApp skin packs + screenshot threads</td>
                      <td>More eye candy, more compatibility homework after updates</td>
                    </tr>
                    <tr>
                      <th scope="row">Backup before you switch phones</th>
                      <td>Official backup habit + whichever mod you pick</td>
                      <td>Mods sometimes rename prompts—don’t skip steps</td>
                    </tr>
                    <tr>
                      <th scope="row">Still on the fence about sideloading</th>
                      <td><router-link :to="{ name: 'en-disclaimer' }">Disclaimer</router-link></td>
                      <td>Know what you’re signing up for before you chase links</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section class="og-compare-section" aria-labelledby="sec-dimensions">
              <h2 id="sec-dimensions">OG WhatsApp vs GB WhatsApp: features mods often ship</h2>
              <div class="og-compare-table-scroll">
                <table class="og-compare-table">
                  <caption class="og-compare-caption">Reality check per row</caption>
                  <thead>
                    <tr>
                      <th scope="col">Area</th>
                      <th scope="col">OG WhatsApp</th>
                      <th scope="col">GB WhatsApp</th>
                      <th scope="col">Double-check</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Status</th>
                      <td>Save, hide view, stretch length—when the dev ships it</td>
                      <td>Same crowd-pleasers, flashier UI on some builds</td>
                      <td>Gallery permission after updates</td>
                    </tr>
                    <tr>
                      <th scope="row">Groups</th>
                      <td>“Leave me alone” toggles first</td>
                      <td>Bulk toys + styling</td>
                      <td>Test weird automation on a tiny group first</td>
                    </tr>
                    <tr>
                      <th scope="row">Media</th>
                      <td>Bigger sends, less compression drama</td>
                      <td>Same fight, different default caps</td>
                      <td>File size vs. carrier limits</td>
                    </tr>
                    <tr>
                      <th scope="row">Account</th>
                      <td>Still OTP + phone number</td>
                      <td>Still OTP + phone number</td>
                      <td>Backup before swapping packages</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <div class="og-compare-cards">
              <div class="og-compare-card">
                <h3 class="og-compare-card__title">OG WhatsApp — what people like</h3>
                <ul class="og-compare-card__list">
                  <li>Privacy switches sit where you’d expect after a day of use.</li>
                  <li>Our <router-link :to="{ name: 'en-download' }">OG WhatsApp APK</router-link> page keeps file chatter in one lane.</li>
                </ul>
                <h3 class="og-compare-card__title">OG WhatsApp — don’t kid yourself</h3>
                <ul class="og-compare-card__list">
                  <li>Third-party APK: you own the risk chain.</li>
                  <li>Forks fork—screenshot weird menus before you update.</li>
                </ul>
              </div>
              <div class="og-compare-card">
                <h3 class="og-compare-card__title">GB WhatsApp — what people like</h3>
                <ul class="og-compare-card__list">
                  <li>Theme rabbit holes for days.</li>
                  <li>Old forum posts sometimes save you when an install throws the same error code.</li>
                </ul>
                <h3 class="og-compare-card__title">GB WhatsApp — don’t kid yourself</h3>
                <ul class="og-compare-card__list">
                  <li>Every new toggle is another toggle to audit.</li>
                  <li>“Easy” mirrors are rarely the honest ones.</li>
                </ul>
              </div>
            </div>

            <section class="og-compare-section" aria-labelledby="sec-install">
              <h2 id="sec-install">Installing OG WhatsApp or GB WhatsApp: good habits</h2>
              <ol class="og-compare-steps">
                <li><strong>Source:</strong> one publisher you picked on purpose—not five random mirrors.</li>
                <li><strong>Hashes:</strong> if the dev posts them, use them; if not, slow down.</li>
                <li><strong>Permissions:</strong> new junk you didn’t expect? Stop and ask why.</li>
                <li><strong>Backup:</strong> before overwrite installs, same as always.</li>
                <li><strong>OS jumps:</strong> read fresh chatter before flashing day-one.</li>
              </ol>
            </section>

            <section class="og-compare-section" aria-labelledby="sec-safety">
              <h2 id="sec-safety">OG WhatsApp, GB WhatsApp, and account safety</h2>
              <p>Mods can get your account flagged. “Anti-ban” is marketing, not a contract. If the APK smells off, sleep on it.</p>
              <ul>
                <li>Fine print: <router-link :to="{ name: 'en-disclaimer' }">Disclaimer</router-link>.</li>
                <li>Site data: <router-link :to="{ name: 'en-privacy' }">Privacy Policy</router-link>.</li>
              </ul>
            </section>

            <section class="og-compare-section" aria-labelledby="sec-decision">
              <h2 id="sec-decision">OG WhatsApp or GB WhatsApp: which should you use?</h2>
              <p>
                Whichever APK you can name, version, and re-download six months from now. If you already read us for OG WhatsApp, grab the build from <router-link :to="{ name: 'en-download' }">download</router-link>, jot the file size, and move on. Still fuzzy on terms? Skim <router-link :to="{ name: 'en-og' }">home</router-link> first.
              </p>
            </section>

            <section class="og-compare-section og-compare-faq" aria-labelledby="sec-faq">
              <h2 id="sec-faq">OG WhatsApp vs GB WhatsApp: short FAQ</h2>
              <div class="og-compare-faq__grid">
                <div class="og-compare-faq__item">
                  <p class="og-compare-faq__q">One-line winner?</p>
                  <p class="og-compare-faq__a">Nope. Phone use + patience + trust in the file beat brand loyalty.</p>
                </div>
                <div class="og-compare-faq__item">
                  <p class="og-compare-faq__q">Will this age badly?</p>
                  <p class="og-compare-faq__a">Yes—mods ship fast. Your installed build is the real changelog.</p>
                </div>
                <div class="og-compare-faq__item">
                  <p class="og-compare-faq__q">Official?</p>
                  <p class="og-compare-faq__a">We’re not WhatsApp or Meta—just a small site writing what we’ve learned.</p>
                </div>
              </div>
            </section>
          </article>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'CompareOgVsGb',
  components: { HeadNav },
  data() {
    return {
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      // 下载链接仍可能走既有推广接口；实际包名以接口与环境变量为准
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style scoped>
.og-compare-wrap {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.og-page-prose.inside-article.section-content.og-compare-article {
  width: 100% !important;
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  padding: 24px max(16px, env(safe-area-inset-right)) 48px max(16px, env(safe-area-inset-left));
  box-sizing: border-box;
  background: #fafcfb;
  border: 1px solid #e8eeec;
  border-radius: 8px;
}

.og-compare-header .entry-title {
  color: #204f46;
  font-size: clamp(1.35rem, 2.5vw, 1.85rem);
  line-height: 1.3;
  margin-bottom: 0.75rem;
}

.lead {
  font-size: 1.05rem;
  line-height: 1.75;
  color: #333;
  margin: 0 0 1rem;
}

.og-compare-section {
  margin-top: 1.75rem;
}

.og-compare-section h2 {
  color: #204f46;
  font-size: 1.28rem;
  margin: 0 0 0.65rem;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #d5e5e1;
}

.og-compare-section h2 + p {
  margin-top: 0.5rem;
}

.og-compare-article p {
  font-size: 1.02rem;
  line-height: 1.75;
  color: #2a332f;
  margin: 0 0 0.85rem;
}

.og-compare-article ul {
  padding-left: 1.25rem;
  line-height: 1.7;
  color: #2a332f;
  margin: 0 0 0.85rem;
}

.og-compare-article li {
  margin-bottom: 0.45rem;
}

.og-compare-callout {
  margin: 1.25rem 0 0;
  padding: 14px 16px 14px 14px;
  border-left: 4px solid #204f46;
  background: #f0f7f5;
  border-radius: 0 6px 6px 0;
}

.og-compare-callout p {
  margin: 0;
  font-size: 0.98rem;
  line-height: 1.7;
  color: #37403c;
}

.og-compare-table-scroll {
  margin: 1rem 0 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(32, 79, 70, 0.08);
}

.og-compare-caption {
  text-align: left;
  font-size: 0.9rem;
  color: #5a6964;
  padding: 10px 12px 0;
  caption-side: top;
}

.og-compare-table {
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;
  font-size: 0.95rem;
  line-height: 1.55;
  background: #fff;
  border: 1px solid #dfe8e4;
}

.og-compare-table th,
.og-compare-table td {
  padding: 12px 14px;
  border: 1px solid #e5ebe8;
  vertical-align: top;
  text-align: left;
  color: #2a332f;
}

.og-compare-table thead th {
  background: #204f46;
  color: #fff;
  font-weight: 600;
}

.og-compare-table tbody th[scope='row'] {
  background: #f4faf8;
  color: #1a3d36;
  font-weight: 600;
  white-space: nowrap;
}

.og-compare-table--compact {
  min-width: 520px;
}

.og-compare-table tbody tr:nth-child(even) {
  background: #fbfcfc;
}

.og-compare-cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 1.75rem;
}

@media (min-width: 768px) {
  .og-compare-cards {
    grid-template-columns: 1fr 1fr;
  }
}

.og-compare-card {
  background: #fff;
  border: 1px solid #dfe8e4;
  border-radius: 8px;
  padding: 16px 18px;
  box-sizing: border-box;
}

.og-compare-card__title {
  margin: 0 0 0.5rem;
  font-size: 1.05rem;
  color: #204f46;
}

.og-compare-card__title:not(:first-child) {
  margin-top: 1rem;
}

.og-compare-card__list {
  margin: 0;
  padding-left: 1.1rem;
  color: #2a332f;
  line-height: 1.65;
  font-size: 0.98rem;
}

.og-compare-card__list li {
  margin-bottom: 0.4rem;
}

.og-compare-steps {
  margin: 0.75rem 0 0;
  padding-left: 1.2rem;
  line-height: 1.75;
  color: #2a332f;
}

.og-compare-steps li {
  margin-bottom: 0.5rem;
}

.og-compare-faq__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-top: 0.75rem;
}

@media (min-width: 720px) {
  .og-compare-faq__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.og-compare-faq__item {
  background: #fff;
  border: 1px solid #e5ebe8;
  border-radius: 6px;
  padding: 12px 14px;
}

.og-compare-faq__q {
  margin: 0 0 0.4rem;
  font-weight: 600;
  color: #204f46;
  font-size: 0.95rem;
}

.og-compare-faq__a {
  margin: 0;
  font-size: 0.92rem;
  line-height: 1.65;
  color: #444;
}

.og-compare-article :deep(a) {
  color: #204f46;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.og-compare-article :deep(a:hover) {
  color: #34d399;
}
</style>
